import { AdminSectionSettingCodes } from 'const';
import { AdminSettingsState } from 'reducers/admin/adminSettings';
import { createSelector } from 'reselect';
import { configSelector } from 'selectors/common';

import { IRootState } from '../../reducers';

export const adminSettingsSelector = createSelector(
  [(state: IRootState) => state.adminSettings, configSelector],
  (adminSettings, config) => {
    if (!config) {
      const settingsState: AdminSettingsState = {
        ...adminSettings,
        content: {
          sections: [],
        },
      };
      return settingsState;
    }

    const hideUniversitySelection = config?.HIDE_UNIVERSITY_SELECTION === true;

    const filteredSections = adminSettings.content.sections.filter((section) => {
      if (
        hideUniversitySelection &&
        (section.sectionId === AdminSectionSettingCodes.recommendation ||
          section.parentSectionId === AdminSectionSettingCodes.recommendation)
      ) {
        return false;
      }
      return true;
    });

    return {
      ...adminSettings,
      content: {
        sections: filteredSections,
      },
    };
  },
);
